<template>
  <div class="wrap">
    <div class="wrap_box">
      <el-form :model="formamend">
        <el-form-item label="修改之前用户帐号" label-width="120">
          <el-input v-model="formamend.user_before"></el-input>
        </el-form-item>
        <el-form-item label="修改之后用户帐号" label-width="120">
          <el-input v-model="formamend.user_after"></el-input>
        </el-form-item>
        <el-form-item label="修改之后用户密码" label-width="120">
          <el-input v-model="formamend.user_psd"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="clear">清空</el-button>
          <el-button class="btn" @click="onSubmit">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { change_user } from '@/api/hr24_api/api_all.js'
export default {
  data() {
    return {
      formamend: {
        user_before: '',
        user_after: '',
        user_psd: '',
      },
    }
  },
  methods: {
    clear() {
      this.formamend = {
        user_before: '',
        user_after: '',
        user_psd: '',
      }
    },
    onSubmit() {
      console.log(this.formamend)
      let obj = {
        former_company_user: this.formamend.user_before,
        change_company_user: this.formamend.user_after,
        change_company_pwd: this.formamend.user_psd,
      }

      change_user(obj).then((res) => {
        if (!res.code) {
          console.log(res)
          this.clear()
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped>
.wrap {
  padding-top: 54px;
}
.wrap_box {
  width: 440px;
}
</style>
